import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoFull } from "@/components/Logo";
import { API } from "@/lib/api";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (user) navigate("/riservata", { replace: true });
  }, [user, navigate]);

  useEffect(() => {
    const g = params.get("google");
    if (g === "denied") toast.error("Accesso consentito solo agli account @operapartners.it.");
    if (g === "error") toast.error("Accesso con Google non riuscito. Riprova.");
  }, [params]);

  return (
    <div className="min-h-screen bg-[#0D1B2A] flex items-center justify-center px-5 relative noise-overlay">
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-10">
          <LogoFull />
        </div>
        <div className="bg-[#1E2229] border border-white/10 p-8 lg:p-10">
          <div className="flex items-center gap-2 label-eyebrow mb-6">
            <Lock size={14} /> Area riservata
          </div>
          <h1 className="font-display font-light text-2xl text-white mb-4">Accesso soci</h1>
          <p className="text-sm text-gray-400 mb-8 leading-relaxed">
            L'accesso all'area riservata avviene esclusivamente tramite il tuo account Google
            Workspace del dominio @operapartners.it.
          </p>
          <a
            href={`${API}/google/oauth/start`}
            data-testid="login-google"
            className="flex items-center justify-center gap-2 w-full bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D8B978] transition-colors h-12 text-sm font-medium"
          >
            Accedi con Google Workspace
          </a>
        </div>
        <p className="text-center text-xs text-gray-500 mt-6">
          Riservato ai soci di Opera Real Estate Partners
        </p>
      </div>
    </div>
  );
}
